//================================= LANGUAGE SWITCHER

$('.lang-selector__lang--active').on('click', function () {
	$(this).next().slideToggle();
	$(this).parent().toggleClass('lang-selector--active');
});